// @ts-nocheck
import { Handler } from "@insite/client-framework/HandlerCreator";
import {
    CallApi,
    chain,
} from "@insite/client-framework/Store/Components/ProductRecommendations/Handlers/SendProductRecommendationTracking";
import { sendProductRecommendationTracking as sendProductRecommendationTrackingApi } from "@store/Framework/Services/StoreProductRecommendationsService";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<{ recommendationId: number; isNewPageWasOpen: boolean }>;

export const StoreCallApi: HandlerType = ({ parameter: { recommendationId, isNewPageWasOpen } }) => {
    sendProductRecommendationTrackingApi(recommendationId, isNewPageWasOpen);
};
replaceInChain(chain, CallApi, StoreCallApi);
